export function fmt(iso: string) {
  return new Date(iso).toLocaleString();
}

type Details = Record<string, unknown> | null | undefined;

/** Extract a string value from untyped audit log details. */
export function detailStr(d: Details, key: string): string | null {
  const v = d?.[key];
  return typeof v === 'string' ? v : null;
}

/** Extract a numeric value from untyped audit log details. */
export function detailNum(d: Details, key: string): number {
  const v = d?.[key];
  return typeof v === 'number' ? v : 0;
}

/** Extract an array value from untyped audit log details. */
export function detailArr(d: Details, key: string): unknown[] {
  const v = d?.[key];
  return Array.isArray(v) ? v : [];
}
